import { useEffect, useMemo, useState } from 'react';
import { X } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { api } from '../../../services/api';
import CartaConCarrito from '../../../components/CartaConCarrito';
import './StaffCartaSheet.css';

export default function StaffCartaSheet({ table, isOpen, onClose }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [orderSent, setOrderSent] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    setError('');
    setOrderSent(false);
    api.get('/products')
      .then(data => setProducts(Array.isArray(data) ? data.filter(product => product.active !== false) : []))
      .catch(err => setError(err.message || 'No se pudieron cargar los productos'))
      .finally(() => setLoading(false));
  }, [isOpen]);

  const aperitivoExtras = useMemo(
    () => products.filter(product => {
      const price = Number(product.price);
      return product.category === 'aperitivos' &&
        product.active !== false &&
        price > 0 &&
        product.name !== 'Tapa Extra';
    }),
    [products]
  );

  const handleSendOrder = async (cartItems) => {
    if (!table?._id) throw new Error('Mesa no identificada');
    const items = cartItems.map(item => ({
      productId: item.productId || String(item.id).split('__')[0],
      variantIndex: item.variantIndex !== null && item.variantIndex !== undefined ? item.variantIndex : undefined,
      aperitivoId: item.aperitivoId || undefined,
      tapaExtraId: item.tapaExtraId || undefined,
      quantity: item.qty,
      notes: item.notes || undefined
    }));

    await api.post(`/orders/admin/table/${table._id}`, { items });
    setOrderSent(true);
    setTimeout(() => {
      setOrderSent(false);
      onClose?.();
    }, 1400);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="staff-carta-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="staff-carta-sheet"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 28, stiffness: 280 }}
          >
            <div className="staff-carta-header">
              <div className="staff-carta-header-info">
                <span className="staff-carta-header-badge">Personal</span>
                <h2>Pedido — Mesa {table?.number}</h2>
              </div>
              <button className="staff-carta-close" onClick={onClose} aria-label="Cerrar">
                <X size={20} />
              </button>
            </div>

            <div className="staff-carta-body">
              {loading && <div className="staff-carta-loading">Cargando carta...</div>}
              {error && <div className="staff-carta-error">{error}</div>}
              {orderSent && <div className="staff-carta-success">Pedido enviado correctamente</div>}
              {!loading && !error && products.length > 0 && (
                <CartaConCarrito
                  products={products}
                  aperitivoExtras={aperitivoExtras}
                  isActive={true}
                  onSendOrder={handleSendOrder}
                  title={`Pedido — Mesa ${table?.number || ''}`}
                />
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
